import React from "react";

import classes from "./ContactSection.module.css";

const ContactSection = (props) => {
  return (
    <div className={classes.ContactSection}>
      <div className={classes.Contact}>
        <div className={classes.Header}>Contact Us</div>
        <div className={classes.Content}>
          <div>Phone no: 6384674309, 8778796511</div>
          <div>
            1st floor, Thamayanthi building, Near by narayanaguru mandapam
            opposite to kottar bus stop Kottar, nagercovil Tamil Nadu 629001.
          </div>
          <div className={classes.Socials}>
            Socials :
            <a href="https://www.instagram.com/alo_foodie/">
              <svg
                width="22"
                height="22"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 3.5H12M4.5 0.5H10.5C12.7091 0.5 14.5 2.29086 14.5 4.5V10.5C14.5 12.7091 12.7091 14.5 10.5 14.5H4.5C2.29086 14.5 0.5 12.7091 0.5 10.5V4.5C0.5 2.29086 2.29086 0.5 4.5 0.5ZM7.5 10.5C5.84315 10.5 4.5 9.15685 4.5 7.5C4.5 5.84315 5.84315 4.5 7.5 4.5C9.15685 4.5 10.5 5.84315 10.5 7.5C10.5 9.15685 9.15685 10.5 7.5 10.5Z"
                  stroke="black"
                  strokeWidth="1.5"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
